
import { IItemCache } from '../IItemCacheObserver';
import { defaultChildItemSetFacet } from '../../facets/SetFacets';

/**
 * @beta
 */
export function getItemSetKey(itemCache: IItemCache, props: {
  itemKey: string | undefined;
}): string | undefined {
  let itemKey = props.itemKey;

  if (itemKey) {
    const defaultChildItemSet = itemCache.demandItemFacet(defaultChildItemSetFacet, itemKey);

    if (defaultChildItemSet) {
      itemKey = defaultChildItemSet.itemKey;
    }
  }

  return itemKey;
}
